<table
  [ngClass]="{ fewCols: columns && columns.length < 4 }"
  class="comp table-striped compSize borderless"
  width="100%"
  cellspacing="0"
  border="0"
>
  <thead>
    <tr>
      <!-- panel titles -->
      <th
        class="pillar-th"
        *ngFor="let panel of panels"
        [attr.colspan]="panel.tiles.length"
      >
        <p class="pillar-title">
          {{ panel.title }}
        </p>
      </th>
    </tr>
    <tr>
      <!-- kpi titles -->
      <th *ngFor="let column of columns; let last = last" class="metric-header">
        <div
          [tooltip]="titleTooltip"
          [placement]="last ? 'left' : 'bottom'"
          container="body"
        >
          <img
            [src]="'../../assets/images/sort_inactive.svg'"
            (click)="sortColumn(column.id, 'neutral')"
            *ngIf="
              sortCol !== column.id ||
              (sortCol === column.id && sortDirection === 'neutral')
            "
            class="sort-image"
            alt="Sorting neutral"
          />
          <img
            [src]="'../../assets/images/sort_down.svg'"
            (click)="sortColumn(column.id, 'down')"
            *ngIf="sortCol === column.id && sortDirection === 'down'"
            class="sort-image"
            alt="Sorting descending"
          />
          <img
            [src]="'../../assets/images/sort_up.svg'"
            (click)="sortColumn(column.id, 'up')"
            *ngIf="sortCol === column.id && sortDirection === 'up'"
            class="sort-image"
            alt="Sorting ascending"
          />
          <div
            class="kpi-title"
            data-id="OurSchoolsHeader.Metric.{{ column.id }}"
          >
            {{ column.title }}
          </div>
        </div>
        <ng-template #titleTooltip>
          <title-tooltip
            [definition]="districtOverall[column?.id]?.definition"
            [title]="column?.title"
          ></title-tooltip>
        </ng-template>
      </th>
    </tr>
    <tr class="overall-row">
      <th
        class="overall-col"
        *ngFor="let column of columns; let first = first; let last = last"
      >
        <div
          *ngIf="district[column.id] && district[column.id]['overall'] != null"
          [ngClass]="{
            mega_large_number_container: isMegaLargeNumber(district, column.id)
          }"
        >
          <span
            class="overall-value"
            [class.has-no-goal]="
              district[column.id]['goal'] == null ||
              district[column.id]['goal'] == ''
            "
            [ngStyle]="{ color: districtColors[column.id] }"
            [ngClass]="{
              mega_large_number: isMegaLargeNumber(district, column.id)
            }"
            [tooltip]="districtValueTooltip"
            [placement]="last ? 'left' : 'top'"
            container="body"
          >
            {{ district[column.id]["overallPrefix"]
            }}{{ district[column.id]["overall"] | number
            }}{{ district[column.id]["overallSuffix"] }}
          </span>
          <span class="goal-value">{{ district[column.id]["goal"] }}</span>
        </div>
        <div
          *ngIf="
            district[column.id] == null ||
            (district[column.id] && district[column.id]['overall'] == null)
          "
          class="no-data-col"
        >
          <img
            [src]="'../assets/images/no_data.png'"
            class="no-data-image"
            alt="No data available!"
            container="body"
            [tooltip]="districtValueTooltip"
            [placement]="last ? 'left' : 'top'"
          />
        </div>

        <ng-template #districtValueTooltip>
          <comp-overall-value-tooltip
            [overallData]="district"
            [column]="column"
            [overallDataColors]="districtColors"
          ></comp-overall-value-tooltip>
        </ng-template>
      </th>
    </tr>
  </thead>
</table>
